import { Injectable } from '@angular/core';
import { HashMap, TranslocoService } from '@ngneat/transloco';
import {
  TokenizeResult,
  TranslationMarkupRendererFactory,
  TranslationMarkupTranspiler,
  TranslationMarkupTranspilerContext,
  TranspileResult
} from 'ngx-transloco-markup';
import { TRANSLOCO_TRANSLOCO_SCOPE } from '../transloco-transloco-scope';
import { LocalizationStart, LocalizationTranspilerService } from './localization-transpiler.service';

export class EnumerationStart extends LocalizationStart {
  constructor(override readonly paramsKey: string) {
    super(paramsKey);
  }
}

@Injectable()
export class EnumerationTranspiler implements TranslationMarkupTranspiler {
  constructor(
    private localizationTranspilerService: LocalizationTranspilerService,
    private readonly rendererFactory: TranslationMarkupRendererFactory,
    private translocoService: TranslocoService
  ) {}

  tokenize(translation: string, offset: number): TokenizeResult | undefined {
    return this.localizationTranspilerService.tokenize(translation, offset, 'enumeration', (paramsKey: string) => new EnumerationStart(paramsKey));
  }

  transpile(start: number, context: TranslationMarkupTranspilerContext): TranspileResult | undefined {
    const createText = (translationParameters: HashMap, paramsKey: string): string => {
      const values = (translationParameters[paramsKey] as string[]).join(', ');
      const lastIndex = values.lastIndexOf(',');
      if (lastIndex >= 0) {
        const before = values.slice(0, lastIndex);
        const after = values.slice(lastIndex + 1);
        return before + ' ' + this.translocoService.translate('enumeration.conjunction', undefined, TRANSLOCO_TRANSLOCO_SCOPE) + after;
      }
      return values;
    };

    return this.localizationTranspilerService.transpile(
      start,
      context,
      (translationParameters: HashMap, paramsKey: string) => createText(translationParameters, paramsKey),
      this.rendererFactory,
      (token: unknown) => (token instanceof EnumerationStart ? token.paramsKey : undefined)
    );
  }
}
